import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';

const ICT_PREFIX = 'ICT';
const ITC_PREFIX = 'ITC';
const CTI_PREFIX = 'CTI';
const CIT_PREFIX = 'CIT';
const TIC_PREFIX = 'TIC';
const TCI_PREFIX = 'TCI';

/* eslint-disable */
const propTypes = {
  tickets: PropTypes.array.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object,
  disabled: PropTypes.bool,
};
/* eslint-enable */

export const invalidTicketNumberPrefix = (ticketNumber) => {
  return (
    ticketNumber.startsWith(ICT_PREFIX)
    || ticketNumber.startsWith(ITC_PREFIX)
    || ticketNumber.startsWith(CIT_PREFIX)
    || ticketNumber.startsWith(CTI_PREFIX)
    || ticketNumber.startsWith(TIC_PREFIX)
    || ticketNumber.startsWith(TCI_PREFIX));
};

export class TicketInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      error: null,
      open: false,
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.clearErrorState = this.clearErrorState.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnToggle = this.handleOnToggle.bind(this);
  }

  handleOnChange(value) {
    const { onChange } = this.props;
    onChange(value);
    this.clearErrorState();
  }

  handleOnToggle(open) {
    this.setState({
      open,
    });
  }

  handleOnFocus() {
    this.setState({
      open: true,
    });
  }

  clearErrorState() {
    this.setState({ error: null });
  }

  render() {
    const { tickets, value, disabled } = this.props;
    const { searchTerm, error, open } = this.state;

    return (
      <div>
        <InputGroup>
          <DropdownList
            inputProps={{
              className: 'select',
            }}
            disabled={disabled}
            filter="contains"
            data={tickets}
            value={value}
            open={open}
            onFocus={this.handleOnFocus}
            onToggle={this.handleOnToggle}
            onChange={this.handleOnChange}
            onMouseDown={(e) => { e.preventDefault(); }}
            searchTerm={searchTerm}
            onSearch={(term) => {
              this.setState({
                searchTerm: term.toUpperCase(),
              });

              if (invalidTicketNumberPrefix(term)) {
                this.setState({
                  error: 'Invalid ticket number prefix',
                });
              } else {
                this.clearErrorState();
              }
            }}
            valueField="id"
            textField="number"
          />
          <InputGroup.Button>
            <Button
              name="cancel"
              disabled={!value || disabled}
              onClick={() => { this.handleOnChange(null); }}
            >
              <Glyphicon glyph="remove" />
            </Button>
          </InputGroup.Button>
        </InputGroup>
        <span className="form-error">
          {error}
        </span>
      </div>
    );
  }
}

TicketInput.propTypes = propTypes;

TicketInput.defaultProps = {
  disabled: false,
};

export default TicketInput;
